<input type="text" nbInput fullWidth id="parcelaregion" name="parcelaregion" [(ngModel)]="cell.newValue"
                    [nbAutocomplete]="autoControl" focusInputOnValueChange="false"/>

                    <nb-autocomplete #autoControl >

                      <nb-option *ngFor="let unidad of unidades$ | async" [value]="unidad.value">
                        {{ unidad.value }}
                      </nb-option>

                    </nb-autocomplete>
